import palette from '@lib/core/src/theme/palette';
import { Stack, styled } from '@mui/material';

export const InputWrapper = styled(Stack)({
  height: '42px',
  width: '100%',
  position: 'relative'
});

export const Container = styled(Stack)({
  position: 'absolute',
  bottom: '0',
  left: '0',
  flexDirection: 'row',
  alignItems: 'flex-end',
  justifyContent: 'flex-start',
  gap: '12px',
  width: '100%',
  backgroundColor: palette.white,
  borderRadius: '21px',
  border: `1px solid ${palette.grey[1200]}`,
  boxShadow: '0px 4px 2px -2px rgba(24, 39, 75, 0.05)'
});

export const ButtonContainer = styled(Stack)({
  alignItems: 'center',
  justifyContent: 'center',
  height: '28px',
  width: '28px',
  borderRadius: '50%',
  backgroundColor: palette.black
});
